import * as types from '../constants/ActionTypes';

const initialState = {
  elmoTreatments: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.ELMO_EXPERIMENTS_RECEIVED:
      return Object.assign({}, state, { elmoTreatments: [...state.elmoTreatments, ...action.payload] });
    case types.ELMO_EXPERIMENTS_ERROR:
      return Object.assign({}, state, { elmoTreatments: [...state.elmoTreatments] });
    default:
      return state;
  }
}
